import { render } from "./BaseCreateUser.vue?vue&type=template&id=76f477ec"
import script from "./BaseCreateUser.vue?vue&type=script&lang=js"
export * from "./BaseCreateUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__